export default function(minutos) {
  const horas = Math.floor(Math.abs(minutos / 60)),
      resto = Math.abs(minutos % 60),
      partes = [
        horas ? horas + 'h' : '',
        resto ? resto + 'm' : ''
      ];

  return partes.join('') || '—';
}